// Widget scripts
import './js/videoWidgetSimpleCustom.js';
import cardWidget from './js/widgets/cardWidget.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import swiperWidgetSecond from './js/widgets/swiperWidgetSecond.js';
import videoWidget from './js/widgets/videoWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import cardWidgetMap from './js/widgets/cardWidgetMap.js';
import cardWidgetFooterSeo from './js/widgets/cardWidgetFooterSeo.js';
import seoWidgetFairMode from './js/widgets/seoWidgetFairMode.js';
import cardWidgetFairMode from './js/widgets/cardWidgetFairMode.js';
import videoWidgetSecond from './js/widgets/videoWidgetSecond.js';
// import cardWidgetMapFairMode from './js/widgets/cardWidgetMapFairMode.js';
import cardWidgetFooterSeoFairMode from './js/widgets/cardWidgetFooterSeoFairMode.js';
// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidget();   
    swiperWidget();
    seoWidget();
    cssSponsors();
    multiScheduleFeature();
    cardWidgetMap();
    seoWidgetFairMode();
    cardWidgetFairMode();
    videoWidget();
    swiperWidgetSecond();
    // cardWidgetMapFairMode();
  });
}
// initialize site-wide widgets
$(document).ready(function () {
  cardWidgetFooterSeo();
  cardWidgetFooterSeoFairMode(); 
  setTimeout(function () {
    videoWidgetSecond();
  }, 1000)
});